import React from "react";
import { connect } from "react-redux";
import { Trans, withTranslation } from "react-i18next";
import { Translation } from "react-i18next";
import { withRouter } from "react-router-dom";
import Moment from "moment";
import {
  getShipManagementDetails,
  getShipEquipmentDetails,
  UpdateEquipmentDetails,
  getShipManagementList,
} from "../Actions/ShipManagementAPI";
import {
  getShipSearchlist,
} from "../Actions/MMPLDashboardAPI";
import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";
import { confirmAlert } from "react-confirm-alert";
import userRoles from "../helpers/role";
import { DownloadFirePlanAttachment } from "../Actions/AttachmentAPI";

let currentuser = JSON.parse(localStorage.getItem("currentUser"));
let user = localStorage.getItem("UserRoles");
let searchData = {
    IsClient: false,
    shipName: "",
    category: "",
    imoNo: "",
    client: "",
    status: "Pending",
    serviceStatus: "",
    nextServiceDateFrom: "",
    nextServiceDateTo: "",
    pagesize: 25,
    pagenumber: 1,
    noofrecords: 2,
    ServiceTypes: [],
    isTotalShips: true,
    isOverdueShips: false,
    isShipsDue10: false,
    isShipsDue30: false,
    isShipsDue60: false,
    isShipsDue90: false,
    action: 1,

};

class ShipEquipmentDetails extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      id: "",
      inContract: false,
      notInContract: false,
      isBoth: true,
    };
  }
  componentDidUpdate() {
    window.onpopstate = (e) => {
      //your code...
      this.props.dispatch({ type: "ShowSidePan", data: false });
    };
  }
  componentDidMount() {
    const { match, dispatch } = this.props;
    const { params } = match;
    const { id } = params;
    dispatch(getShipEquipmentDetails(id));
  }

  hideSidePanel = () => {
    this.props.dispatch({ type: "ShowSidePan", data: false });
    // this.props.history.push("/Home/ShipManagement");
    this.props.history.goBack();
  };
  render() {
    const { ShipEquipment,t } = this.props;
    return (
      <div className="full-height">
        <div className="pt-3">
          <div className="row">
            <div className="col-lg-12">
              <div className="resource-list-auth-date">
                <div className="panel-box search-filter-box">
                  <button
                    className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                    onClick={() => this.hideSidePanel()}
                  >
                    &larr; {t("CommonText.Return")}
                  </button>
                  <div
                    className="card mt-2 MM-card-header"
                    style={{ backgroundColor: "white" }}
                  >
                    <div
                      className="card-body"
                      style={{
                        padding: "0rem",
                        backgroundColor: "#1a3464",
                        color: "white",
                      }}
                    >
                      <h5
                        className="card-title ml-2 mt-2"
                        style={{ color: "092a51" }}
                      >
                        {t("ComplianceandBudgetScreen.Equipments")}
                      </h5>
                    </div>
                    <div className="pt-3 search-filter-box history-box">
                      {ShipEquipment?.length !== 0 ? (
                        ShipEquipment?.map((item) => (
                          <div
                            className="card MM-card-content mb-2 click"
                            style={{
                              backgroundColor: "#f0f0f0",
                              overflow: "hidden",
                              position: "relative",
                            }}
                          >
                            <div className="p-3">
                              <div className="resource-list-auth-date">
                                <div className="row">
                                  <div className="col-md-11 col-sm-10 col-10 m-auto">
                                    <div className="row">
                                      <div className="col-sm-12 mb-2">
                                        <h6 className="resource-list-title">
                                          {item.equipment}{" "}
                                        </h6>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("CategoryScreen.Title")} : </strong>
                                          {item.category}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("ComplianceandBudgetScreen.Type")} : </strong>
                                          {item.equipmentType}{" "}
                                        </span>
                                      </div>
                                      { item?.equipment.toLowerCase().includes("lifeboat")?
                                        <>
                                         <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.LifeboatMake")} :{" "} </strong>
                                          {item.lifeboatMake}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.Davit/winchMake")} :{" "} </strong>
                                          {item.davitwinchMake}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.LifeboatModel")} :{" "} </strong>
                                          {item.lifeboatModel}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.LifeboatRelease")} :{" "} </strong>
                                          {item.lifeboatRelease}{" "}
                                        </span>
                                      </div>
                                        </>
                                        :item?.equipment.toLowerCase().includes("rescue boat")?
                                        <>
                                           <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.rescueboatMake")} :{" "} </strong>
                                          {item.rescueboatMake}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.rescueboatDavit/winchMake")} :{" "} </strong>
                                          {item.rescueboatdavitwinchMake}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("EditEquipmentScreenContent.rescueboatModel")} :{" "} </strong>
                                          {item.rescueboatModel}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong> {t("EditEquipmentScreenContent.rescueboatRelease")} :{" "} </strong>
                                          {item.rescueboatRelease}{" "}
                                        </span>
                                      </div>
                                        </>
                                        :
                                        <>
                                        <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Make")} : </strong>
                                          {item.make}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6 mb-2">
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Model")} : </strong>
                                          {item.model}{" "}
                                        </span>
                                      </div></>}
                                      <div className="col-sm-6">
                                        <span>
                                          <strong> {t("ShipEquipmentStatusScreen.ManufacturingDate")} : </strong>
                                          {Moment(
                                            new Date(
                                              Date.parse(
                                                item.manufracturingDate
                                              )
                                            )
                                          ).format("DD MMM YYYY")}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6">
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Quantity")} : </strong>
                                          {item.quantity >0 ? item.quantity:""}{" "}
                                        </span>
                                      </div>
                                      <div className="col-sm-6">
                                          <span>
                                            <strong>{t("ShipEquipmentStatusScreen.Unit-Quantity")} : </strong>
                                            {item.unit}{" "}
                                          </span>
                                        </div>
                                      <div className="col-sm-6">
                                        <span>
                                          <strong>{t("ShipEquipmentStatusScreen.Capacity")} : </strong>
                                          {item.capacity}{" "}
                                        </span>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="col-md-1 col-sm-2 col-2 m-auto">
                                    <i
                                      className="fa fa-eye fa-2x click"
                                      aria-hidden="true"
                                      onClick={() =>
                                        this.ViewEquipment(
                                          item.equipmentId,
                                          item.shipEquipmentId
                                        )
                                      }
                                      style={{
                                        color: "#1a3464",
                                        marginLeft: "-10px",
                                      }}
                                    ></i>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))
                      ) : (
                        <div
                          className="card MM-card-content mb-2 click"
                          style={{
                            backgroundColor: "#f0f0f0",
                            overflow: "hidden",
                            position: "relative",
                          }}
                        >
                          <div className="p-3">
                            <div className="col-lg-12 resource-list-auth-date">
                              <div className="row">
                                <div className="col-md-12 col-sm-12 col-lg-12 col-12 m-auto">
                                  <h6 className="row resource-list-title">
                                  {t("CommonText.NoEquipmentMsg")}
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div
                    className={user === userRoles.approver ? "d-none" : "row"}
                  >
                    <div className="col-lg-12 pb-2 pt-2">
                      <div
                        className="search-btn-col mt-1"
                        style={{ textAlign: "right" }}
                      >
                        <button
                          className="btn btn-primary text-uppercase txtside-btn txtht-btn blue"
                          type="submit"
                          onClick={() => this.EditShipDetails()}
                        >
                       {t("IntervelScreen.Edit")}
                        </button>
                        <button
                          className="btn btn-light text-uppercase txtside-btn txtht-btn ml-3"
                          type="button"
                          onClick={() => this.deleteShipDetails()}
                        >
                          {" "}
                          {t("CommonText.Delete")}{" "}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
  ViewEquipment(id, shipEquipmentId) {
    this.props.history.push(`/Home/View/Equipment/${id}/${shipEquipmentId}`);
  }
  DownloadDoc(firePlanName, firePlanGUID) {
    this.props.dispatch(DownloadFirePlanAttachment(firePlanName, firePlanGUID));
  }

  EditShipDetails() {
    this.props.history.push(
      `/Home/GrandAdmin/ShipEditItem/${this.props.match.params.id}`
    );
    this.props.dispatch({ type: "ShowSidePan", data: false });
  }
  deleteShipDetails() {
    const { ShipDetails, dispatch, ShipEquipment ,t} = this.props;
    confirmAlert({
      message: `${t("confirmAlertMessage.DeleteMsg")}`,
      buttons: [
        {
          label: `${t("confirmAlertMessage.Yes")}`,
          onClick: () => {
            let shipInfo = {
              shipId: this.props.match.params.id,
              contractId: ShipDetails.contractId ? ShipDetails.contractId : 0,
              shipName: ShipDetails.shipName,
              flag: ShipDetails.flag,
              class: ShipDetails.class ? ShipDetails.class.toString() : "", 
              grt: ShipDetails.grt,
              imoNo: ShipDetails.imoNo,
              deadWeight: ShipDetails.deadWeight,
              dateOfBuild: ShipDetails.dateOfBuild,
              typeOfShip: ShipDetails.typeOfShip,
              shipEmail: ShipDetails.shipEmail,
              approverId:ShipDetails.approverId,
              grantAdminId:ShipDetails.grantAdminId,
              status:ShipDetails.status,
              invoiceForwardingEmail: ShipDetails.invoiceForwardingEmail,
              vesselGroupEmail: ShipDetails.vesselGroupEmail,
              phone1: ShipDetails.phone1,
              phone2: ShipDetails.phone2,
              companyName: ShipDetails.companyName,
              fleetManager: ShipDetails.fleetManager,
              technicalSuperintendent: ShipDetails.technicalSuperintendent,
              technicalExecutive: ShipDetails.technicalExecutive,
              contractName: ShipDetails.contractName,
              contractStatus: ShipDetails.contractStatus,
              isDeleted: true,
              modifiedBy: currentuser.name,
              shipUsers: [
                {
                  userName: ShipDetails.fleetManager,
                  role: "fleetmanager",
                },
                {
                  userName: ShipDetails.technicalSuperintendent,
                  role: "superintendent",
                },
                {
                  userName: ShipDetails.technicalExecutive,
                  role: "technicalexecutive",
                },
              ],
            };
            let equip = ShipEquipment
              ? ShipEquipment.map((item) => {
                  let equipmentinfo = {
                    shipId: item.shipId,
                    equipmentId: item.equipmentId,
                    equipmentContractTypeId: item.equipmentContractTypeId ? item.equipmentContractTypeId : 0,
                    shipEquipmentId: item.shipEquipmentId,
                    equipment: item.equipment,
                    manufracturingDate: item.manufracturingDate,
                    makeId: item.makeId,
                    modelId: item.modelId,
                    quantity: item.quantity,
                    serviceDetails: item.serviceDetails,
                    modifiedBy: currentuser.name,
                    isDeleted: true,
                  };
                  return equipmentinfo;
                })
              : [];
            let url = `${API.getShipDetail}`;
            axios
              .put(url, shipInfo)
              .then((response) => {
                dispatch(UpdateEquipmentDetails(equip));
                this.hideSidePanel();

                dispatch({
                  type: "UpdateShipDetailSuccess",
                  data: response.data,
                });
                toast.success(`${t("CommonText.CommonDelete")}`, {
                  position: "top-right",
                  autoClose: 5000,
                  hideProgressBar: true,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
                dispatch(getShipSearchlist(searchData,this.state.inContract,this.state.isBoth));
              })
              .catch((error) => {
                dispatch({
                  type: "UpdateShipDetailFailure",
                  data: "error",
                });
              });
          },
        },
        {
          label: `${t("confirmAlertMessage.No")}`,
          onClick: () => {},
        },
      ],
    });
  }
}
function mapDispatchToProps(dispatch) {
  return {
    dispatch,
  };
}
function mapStateToProps(state) {
  return {
    ShowMISidePan: state.SidePanReducer.ShowMISidePan || false,
    ShowRDSidePan: state.SidePanReducer.ShowRDSidePan || false,
    ShowEURegSidePan: state.SidePanReducer.ShowEURegSidePan || false,
    ShipDetails: state.MasterScreenReducer.ShipManagementDetails,
    ShipEquipment: state.MasterScreenReducer.ShipEquipmentDetails,
  };
}
export default  withTranslation()(withRouter(
  connect(mapStateToProps, mapDispatchToProps)(ShipEquipmentDetails)
));
